export default function LoanOverview({
  badge,
  title,
  description,
  items = [],
}) {
  return (
    <section id="overview" className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="max-w-3xl mx-auto text-center">
          {badge && (
            <span className="text-primary font-semibold uppercase tracking-wider">
              {badge}
            </span>
          )}

          <h2 className="mt-3 text-3xl md:text-4xl font-bold text-slate-900">
            {title}
          </h2>

          <p className="mt-6 text-lg text-slate-600 leading-8">{description}</p>
        </div>

        <div className="grid md:grid-cols-2 xl:grid-cols-4 gap-8 mt-16">
          {items.map((card) => {
            const Icon = card.icon;

            return (
              <div
                key={card.title}
                className="rounded-2xl border border-slate-200 p-8 bg-white hover:shadow-lg transition-all"
              >
                <div className="w-14 h-14 rounded-xl bg-primary/10 flex items-center justify-center text-primary">
                  <Icon className="w-7 h-7" />
                </div>

                <h3 className="mt-6 text-xl font-semibold">{card.title}</h3>

                <p className="mt-4 text-slate-600 leading-7">
                  {card.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
